/* import __COLOCATED_TEMPLATE__ from './transfer-recurring-outage-banner.hbs'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { formatTimeRange, formatDateTimeWithBrowserTimezone } from '@banking/ui/utils/format-date-time';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { ListTransferInstrumentOutagesResponse } from '@square/dashboard-protos/models/squareup/deposits/service';
const OutageCategory = ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage.OutageCategory;
const OutageType = ListTransferInstrumentOutagesResponse.InstrumentOutageInformation.InstrumentOutage.OutageType;

/**
 * Properties needed to display a banner. These depend on the type of outage.
 */
/**
 * Renders a banner for a transfer instrument outage.
 */
let TransferRecurringOutageBanner = (_class = class TransferRecurringOutageBanner extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "localeTime", _descriptor2, this);
  }
  get outage() {
    return this.args.outages?.[0]?.instrumentOutage?.[0];
  }
  get outageCategory() {
    const {
      outageCategory
    } = this.outage ?? {};
    return outageCategory ?? OutageCategory.UNKNOWN_OUTAGE_CATEGORY_DO_NOT_USE;
  }
  get shouldRenderBanner() {
    return this.bannerPropsBasedOnOutageCategory.isValidForRender;
  }
  get title() {
    return this.bannerPropsBasedOnOutageCategory.title;
  }
  get body() {
    return this.bannerPropsBasedOnOutageCategory.body;
  }
  get variant() {
    return this.bannerPropsBasedOnOutageCategory.variant;
  }
  get bannerPropsBasedOnOutageCategory() {
    const outage = this.outage;
    switch (this.outageCategory) {
      case OutageCategory.PLANNED:
        {
          // Planned outages can be either ACTIVE or SCHEDULED; they have different
          // variants and copy
          switch (outage.outageType) {
            case OutageType.ACTIVE:
              {
                return {
                  isValidForRender: Boolean(outage?.endTime),
                  title: this.intl.t('banking.instantTransfers.outageBanner.planned.active.title'),
                  body: this.formatBodyForPlannedActiveOutage(outage),
                  variant: 'warning'
                };
              }
            case OutageType.SCHEDULED:
            default:
              {
                return {
                  isValidForRender: Boolean(outage?.startTime && outage?.endTime),
                  title: this.intl.t('banking.instantTransfers.outageBanner.planned.scheduled.title'),
                  body: this.formatBodyForPlannedScheduledOutage(outage),
                  variant: 'info'
                };
              }
          }
        }
      case OutageCategory.RECURRING:
      default:
        {
          return {
            isValidForRender: outage?.outageType === OutageType.ACTIVE && Boolean(outage?.startTime) && Boolean(outage?.endTime),
            title: this.intl.t('banking.instantTransfers.outageBanner.recurring.title'),
            body: this.formatBodyForRecurringOutage(outage),
            variant: 'info'
          };
        }
    }
  }
  formatBodyForPlannedActiveOutage(outage) {
    const {
      endTime
    } = outage ?? {};
    if (!endTime) {
      return '';
    }
    const {
      formattedDate
    } = formatDateTimeWithBrowserTimezone(endTime, this.intl, true);
    return this.intl.t('banking.instantTransfers.outageBanner.planned.active.body', {
      endTime: formattedDate
    });
  }
  formatBodyForPlannedScheduledOutage(outage) {
    const {
      startTime,
      endTime
    } = outage ?? {};
    if (!startTime || !endTime) {
      return '';
    }
    const {
      formattedDate: formattedStart
    } = formatDateTimeWithBrowserTimezone(startTime, this.intl,
    // We only want to display the time zone for the end date
    false);
    const {
      formattedDate: formattedEnd
    } = formatDateTimeWithBrowserTimezone(endTime, this.intl, true);
    return this.intl.t('banking.instantTransfers.outageBanner.planned.scheduled.body', {
      startTime: formattedStart,
      endTime: formattedEnd
    });
  }
  formatBodyForRecurringOutage(outage) {
    const {
      startTime,
      endTime
    } = outage ?? {};
    if (!startTime || !endTime) {
      return '';
    }

    // e.g. 6:00 - 7:00 AM
    const {
      formattedStart,
      formattedEnd
    } = formatTimeRange(startTime, endTime, this.localeTime);
    return this.intl.t('banking.instantTransfers.outageBanner.recurring.body', {
      startTime: formattedStart,
      endTime: formattedEnd
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "localeTime", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TransferRecurringOutageBanner as default };